import { inject, Injectable } from '@angular/core';

import { AdminFontsStore } from '../+state/admin-fonts.store';
import { FontApiResponse, FontFilter } from '../entities/font.types';

@Injectable({ providedIn: 'root' })
export class AdminFontsFacade {
  private readonly store = inject(AdminFontsStore);

  readonly fonts = this.store.fonts;
  readonly filteredFonts = this.store.filteredFonts;
  readonly loading = this.store.loading;
  readonly error = this.store.error;
  readonly togglingFontId = this.store.togglingFontId;
  readonly toggleErrorFontId = this.store.toggleErrorFontId;
  readonly searchQuery = this.store.searchQuery;
  readonly fontFilter = this.store.fontFilter;

  loadFonts(): Promise<void> {
    return this.store.loadFonts();
  }

  toggleFontPublic(font: FontApiResponse): Promise<void> {
    return this.store.toggleFontPublic(font);
  }

  setSearch(query: string): void {
    this.store.setSearch(query);
  }

  setFilter(filter: FontFilter): void {
    this.store.setFilter(filter);
  }
}
